import { render } from "./AccessGroups.vue?vue&type=template&id=6b140771&scoped=true"
import script from "./AccessGroups.vue?vue&type=script&lang=js"
export * from "./AccessGroups.vue?vue&type=script&lang=js"

import "./AccessGroups.vue?vue&type=style&index=0&id=6b140771&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b140771"]])

export default __exports__